import { TspFieldType } from '@entities/tsp'

export const findVouchersEnumId = (service) =>
  // закомментил, т.к. для селектов будет задаваться тип ComboBox и будет браться enumId не с ваучеров, а с селекта
  service?.params?.find(
    (item) =>
      /* item.type === TSP.ComboBox || */ item.type === TspFieldType.Vouchers || item.name === TspFieldType.Vouchers
  )?.enumId || null
